/**
 * Created by Administrator on 2017/7/13.
 */
import {TOGGLESIDER,LOGINGMODAL,LOGINSUBMIT,LOGINCLOSED} from './actionTypes.js';

export default (state=this.state, action) => {
    switch (action.type) {
        case TOGGLESIDER: {
            return {
                collapsed: action.newState,
                modal:{
                    visible:false,
                    modalText:'this is my text',
                    confirmLoading: false
                }
            };
        }
        case LOGINGMODAL: {
            return {
                collapsed: false,
                modal:{
                    visible:true,
                    modalText:'this is my text',
                    confirmLoading: false
                }
            };
        }
        case LOGINSUBMIT: {
            return {
                collapsed: false,
                modal:{
                    visible:true,
                    modalText:'this is my text',
                    confirmLoading: true
                }
            };
        }
        case LOGINCLOSED: {
            return {
                collapsed: false,
                modal:{
                    visible:false,
                    modalText:'this is my text',
                    confirmLoading: false
                }
            };
        }
        default: {
            return {
                collapsed: true,
                modal:{
                    visible:false,
                    modalText:'this is my text',
                    confirmLoading: false
                }
            };
        }
    }
}


// WEBPACK FOOTER //
// ./src/Pages/blog/reducer.js